import axios from 'axios'
import axiosInstance from '../utils/axiosInstance'
import { API_END_POINT } from '../utils/environment'
import {
  BulkUploadFilesType,
  PayloadGetDocumentTemplateByPageType,
} from '../types'

const getSelectedFileApi = async (
  selectedTenantId: number,
  fileName: string
) => {
  return await axiosInstance.get(
    `${API_END_POINT.CORE}v1/files/generate-download-url?fileName=${fileName}`,
    {
      headers: {
        'x-tenantid': selectedTenantId,
      },
    }
  )
}

const bulkUploadAPI = async (
  payload: BulkUploadFilesType[],
  selectedTenantId: number | undefined,
  isMISC?: boolean
) => {
  return await axiosInstance.post(
    `${API_END_POINT.CORE}v3/files/bulk-upload?accessType=${
      isMISC ? 'MISC' : 'STATIC'
    }`,
    payload,
    {
      headers: {
        'Content-Type': 'application/json',
        'x-tenantid': selectedTenantId,
      },
    }
  )
}

const uploadFileAPI = async (
  url: string,
  file: File,
  selectedTenantId: number | undefined,
  tagging_field?: string | undefined,
  documentIdentifierMetaData?: string | undefined
) => {
  return await axios.put(url, file, {
    headers: {
      'Content-Type': file.type,
      'x-tenantid': selectedTenantId,
      ...(tagging_field ? { 'x-amz-tagging': tagging_field } : {}),
      ...(documentIdentifierMetaData
        ? { 'x-amz-meta-DOCUMENT_IDENTIFIER': documentIdentifierMetaData }
        : {}),
    },
  })
}

const bulkDeleteAPI = async (
  selectedRows: string[],
  selectedTenantId: number | undefined
) => {
  return await axiosInstance.delete(
    `${API_END_POINT.CORE}v1/files/bulk-delete`,
    {
      data: [...selectedRows],
      headers: {
        'x-tenantid': selectedTenantId,
      },
    }
  )
}

const getAllStaticDocumentTemplateApi = async (
  payload: PayloadGetDocumentTemplateByPageType
) => {
  const response = await axiosInstance.post(
    `${API_END_POINT.CORE}v1/files/filter/advance?sort=${payload.sort}&page=${
      payload.page - 1
    }&size=${payload.rowsPerPage}`,
    payload?.filter
  )
  return response
}

const stringFilterApiURLStaticDocument = `${API_END_POINT.CORE}dropdown/filter-data/static_docuements/`

export {
  bulkUploadAPI,
  bulkDeleteAPI,
  getSelectedFileApi,
  uploadFileAPI,
  stringFilterApiURLStaticDocument,
  getAllStaticDocumentTemplateApi,
}
